export const JSONPAGEWIDGETPAYLOAD = {
  type: 18,
  component_type: 'Body',
  id: '6569717b7610995c558a55bb',
  template: JSON.stringify({}),
  ordering: 0,
  status: 1,
  is_editable: true,
  name: 'JsonPageWidget',
  widget_category: 2,
};

export const FLOATING_BUTTON = {
  id: '6563159e679a8b29dbd3220f',
  type: 26,
  component_type: 'Body',
  config: {
    scrollToTop: {
      config: {
        '97SCROLL47f9c22c50687bb2bb892': {
          config: {
            isVisible: true,
            actions: {
              handler: '',
              newTab: false,
              type: 3,
            },
            additionalInfo: null,
            btnText: '',
            isEditable: true,
          },
          id: '97SCROLL47f9c22c50687bb2bb892',
          link: '',
          name: 'ScrollToTop1',
          styleConfig: {
            alignment: 'right',
          },
          type: 'ScrollToTop',
        },
      },
      isEnabled: false,
    },
    enquiryForm: {
      config: {
        '97ENQUIRY47f9c22c50687bb2bb891': {
          config: {
            actions: {
              handler: '',
              newTab: true,
              type: 2,
            },
            additionalInfo: null,
            btnText: 'Enquire Now ',
            isEditable: true,
            isVisible: true,
          },
          id: '97ENQUIRY47f9c22c50687bb2bb891',
          link: '',
          name: 'EnquiryForm1',
          styleConfig: {
            alignment: 'right',
          },
          type: 'EnquiryForm',
        },
      },
      formId: '',
      isEnabled: true,
    },
  },
  ordering: 0,
  status: 1,
  is_editable: true,
  name: 'FloatingButton1',
  widget_category: 2,
};

export const THEME_BUILDER_FLOW_TYPE = {
  CREATE: 1,
  UPDATE: 2,
};

export const WIDGET_TYPE = {
  HEADER: 'Header',
  FOOTER: 'Footer',
  MODERN_HEADER: 'ModernHeader',
  MODERN_FOOTER: 'ModernFooter',
} as const;

export const WIDGET_TYPES = {
  TEMPLATE: 'template',
  THEME: 'theme',
  KUI: 'kui',
};

export const ECOMM_HEADERS = [
  'Header1',
  'Header2',
  'Header3',
  'Header4',
  'Header5',
  'Header6',
  'Header7',
  'Header8',
  'Header9',
  'Header10',
  'Header11',
  'Header12',
  'Header13',
  'Header14',
];

export const ECOMM_FOOTERS = ['Footer', 'Footer1', 'Footer2', 'Footer3', 'Footer4'];

const FOOTER_LAYOUT_IMAGE = [
  {
    title: 'Footer',
    name: 'Footer',
    imgUrl: 'https://cdn.dotpe.in/longtail/themes/8073865/OxuD8lQ0.webp',
    propsConfig: { name: 'Footer' },
  },
  {
    title: 'Footer1',
    name: 'Footer1',
    imgUrl: 'https://cdn.dotpe.in/longtail/themes/8073865/DYZwynak.webp',
    propsConfig: { name: 'Footer1' },
  },
  {
    title: 'Footer2',
    name: 'Footer2',
    imgUrl: 'https://cdn.dotpe.in/longtail/themes/8073865/NLxAsrjL.webp',
    propsConfig: { name: 'Footer2' },
  },
  {
    title: 'Footer3',
    name: 'Footer3',
    imgUrl: 'https://cdn.dotpe.in/longtail/themes/8073865/kK32ouV1.webp',
    propsConfig: { name: 'Footer3' },
  },
  {
    title: 'Footer4',
    name: 'Footer4',
    imgUrl: 'https://cdn.dotpe.in/longtail/themes/8073865/MzWmeX8T.webp',
    propsConfig: { name: 'Footer4' },
  },
];

const HEADER_LAYOUT_IMAGE = [
  {
    title: 'Header1',
    name: 'Header1',
    imgUrl: 'https://cdn.dotpe.in/longtail/themes/8073865/DgciMyUJ.webp',
    propsConfig: { name: 'Header1' },
  },
  {
    title: 'Header2',
    name: 'Header2',
    imgUrl: 'https://cdn.dotpe.in/longtail/themes/8073865/A14QMaR2.webp',
    propsConfig: { name: 'Header2' },
  },
  {
    title: 'Header3',
    name: 'Header3',
    imgUrl: 'https://cdn.dotpe.in/longtail/themes/8073865/W5zKmQlA.webp',
    propsConfig: { name: 'Header3' },
  },
  {
    title: 'Header4',
    name: 'Header4',
    imgUrl: 'https://cdn.dotpe.in/longtail/themes/8073865/VRm6Rtfq.webp',
    propsConfig: { name: 'Header4' },
  },
  {
    title: 'Header5',
    name: 'Header5',
    imgUrl: 'https://cdn.dotpe.in/longtail/themes/8073865/YwOrlZ7f.webp',
    propsConfig: { name: 'Header5' },
  },
  {
    title: 'Header6',
    name: 'Header6',
    imgUrl: 'https://cdn.dotpe.in/longtail/themes/8073865/pSm3WFCd.webp',
    propsConfig: { name: 'Header6' },
  },
  {
    title: 'Header7',
    name: 'Header7',
    imgUrl: 'https://cdn.dotpe.in/longtail/themes/8073865/9PKds2fW.webp',
    propsConfig: { name: 'Header7' },
  },
  {
    title: 'Header8',
    name: 'Header8',
    imgUrl: 'https://cdn.dotpe.in/longtail/themes/8073865/9EZU5sar.webp',
    propsConfig: { name: 'Header8' },
  },
  {
    title: 'Header9',
    name: 'Header9',
    imgUrl: 'https://cdn.dotpe.in/longtail/themes/8073865/Fxj1DrWT.webp',
    propsConfig: { name: 'Header9' },
  },
  {
    title: 'Header10',
    name: 'Header10',
    imgUrl: 'https://cdn.dotpe.in/longtail/themes/8073865/JBfWXHfS.webp',
    propsConfig: { name: 'Header10' },
  },
  {
    title: 'Header11',
    name: 'Header11',
    imgUrl: 'https://cdn.dotpe.in/longtail/themes/8073865/dry5wi03.webp',
    propsConfig: { name: 'Header11' },
  },
  {
    title: 'Header12',
    name: 'Header12',
    imgUrl: 'https://cdn.dotpe.in/longtail/themes/8073865/bpM8i1ZM.webp',
    propsConfig: { name: 'Header12' },
  },
  {
    title: 'Header13',
    name: 'Header13',
    imgUrl: 'https://cdn.dotpe.in/longtail/themes/8073865/AYKWj5sp.webp',
    propsConfig: { name: 'Header13' },
  },
  {
    title: 'Header14',
    name: 'Header14',
    imgUrl: 'https://cdn.dotpe.in/longtail/themes/8073865/e7J9Ecma.webp',
    propsConfig: { name: 'Header14' },
  },
];

export const HEADER_FOOTER_VARIANTS = {
  HEADERS: HEADER_LAYOUT_IMAGE.map(({ name, imgUrl }) => ({
    title: name,
    name,
    imgUrl: imgUrl,
    propsConfig: { name },
  })),
  FOOTERS: FOOTER_LAYOUT_IMAGE.map(({ name, imgUrl }) => ({
    title: name,
    name,
    imgUrl: imgUrl,
    propsConfig: { name },
  })),
};

export const HEADER_CONFIGURABLES = {
  NAME: 'headerName',
  BACKGROUND_COLOR: 'headerBgColor',
  LOGIN: 'loginView',
  WHATSAPP: 'whatsappView',
  SHOP_DROPDOWN: 'isShopDropDownEnable',
  STORE_LOGO: 'storeLogoVisible',
};

export const BANNER_BUTTON_TYPES = {
  solid: { text: 'Solid', value: 'solid' },
  outline: { text: 'Outline', value: 'outline' },
  textual: { text: 'Textual', value: 'textual' },
};

export const TEXT_ALIGNMENT_POSITIONS = {
  right: 'right',
  left: 'left',
  center: 'center',
};

export const FLEX_ALIGNMENT_CLASS = {
  right: 'justify-end',
  center: 'justify-center',
  left: 'justify-start',
};

export const GRID_ALIGNMENT_CLASS = {
  top_right: 'tw-top-0 tw-right-0 tw-left-1/2',
  top_center: 'tw-top-0 tw--translate-x-1/2 tw-left-1/2',
  top_left: 'tw-top-0',
  mid_right: 'tw-right-0 tw-top-1/2 tw--translate-y-1/2',
  mid_center: 'tw--translate-y-1/2 tw-top-1/2 tw--translate-x-1/2 tw-left-1/2',
  mid_left: 'tw-left-0 tw-top-1/2 tw--translate-y-1/2 tw-left-1/2',
  bottom_right: 'tw-right-0 tw-bottom-0',
  bottom_center: 'tw-left-1/2 tw-bottom-0 tw--translate-x-1/2',
  bottom_left: 'tw-left-0 tw-bottom-0',
  top: 'tw-top-0',
  middle: 'tw-top-1/2 tw--translate-y-1/2',
  bottom: 'tw-bottom-0',
};

export const MOBILE_DEVICE = 'mobile';
export const DESKTOP_DEVICE = 'dekstop';

export const MULTI_TAB_VALUE = {
  SECTION: 'section',
  GLOBAL_STYLE: 'globalStyle',
} as const;

export const WIDGET_TAB_SELECTION = [
  {
    name: 'Sections',
    value: MULTI_TAB_VALUE.SECTION,
    spriteDetail: 'wb-sprite section-icon',
    selectedSprite: 'wb-sprite section-icon',
  },
  {
    name: 'Site styles',
    value: MULTI_TAB_VALUE.GLOBAL_STYLE,
    spriteDetail: 'wb-sprite global-style-icon',
    selectedSprite: 'wb-sprite global-style-icon',
  },
];
